<template>
  <b-card :title="title">
    <b-row>
      <b-col cols="6">
        <b-form-group id="des-gr" label="توضیحات:" label-for="des">
          <b-form-input
            id="des"
            v-model="Doc.des"
            required
            placeholder="توضیحات"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="date-gr" label="تاریخ:" label-for="date">
          <b-form-input
            id="date"
            v-model="Doc.date"
            required
            placeholder="تاریخ"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="des-gr" label="شماره:" label-for="des">
          <b-form-input
            id="des"
            v-model="Doc.number"
            required
            placeholder="شماره"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group id="des-gr" label="وضعیت سند:" label-for="des">
          <MDDropdown v-bind:group="92" v-model="Doc.mdid92_state"></MDDropdown>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="date-gr" label="نوع سند:" label-for="date">
          <MDDropdown v-bind:group="93" v-model="Doc.mdid93_type"></MDDropdown>
        </b-form-group>
      </b-col>
    </b-row>

    <h3>جزییات سند</h3>
    <b-row class="mt-5">
      <b-col cols="0.5">سرفصل معین</b-col>
      <b-col>سرفصل تفضیلی</b-col>
      <b-col cols="3">شرح</b-col>
      <b-col>بدهکار</b-col>
      <b-col>بستانکار</b-col>
      <b-col>شماره تراکنش</b-col>
      <b-col>شماره درگاه</b-col>
      <b-col>والد</b-col>
    </b-row>
    <b-row class="mt-1" v-for="x in Doc.doc_details" v-bind:key="x.index">
      <b-col cols="0.5">
        {{ x.id }}
      </b-col>
      <b-col>
        <b-form-select :options="Moein" v-model="x.topic_id"></b-form-select>
      </b-col>
      <b-col cols="3">
        <!-- <b-form-select
          :options="Detaileds"
          v-model="x.detail_id"
        ></b-form-select> -->
        <v-select-shepa
          dir="rtl"
          :options="Detaileds"
          :reduce="(item) => item.value"
          label="text"
          :value="x.detail_id"
          v-model="x.detail_id"
          :autocomplete="'on'"
        ></v-select-shepa>
      </b-col>
      <b-col>
        <b-form-input
          v-model="x.des"
          required
          placeholder="توضیحات"
          @focus="addNew()"
        ></b-form-input>
      </b-col>
      <b-col>
        <b-form-input
          v-model="x.bed"
          required
          placeholder="بدهکار"
        ></b-form-input>
      </b-col>
      <b-col>
        <b-form-input
          v-model="x.bes"
          required
          placeholder="بستانکار"
        ></b-form-input>
      </b-col>
      <b-col>
        <b-form-input
          v-model="x.transaction_id"
          required
          placeholder="بستانکار"
        ></b-form-input>
      </b-col>
      <b-col>
        <b-form-input
          v-model="x.acceptorcode"
          required
          placeholder="بستانکار"
        ></b-form-input>
      </b-col>
      <b-col>
        <b-form-input
          v-model="x.parent_id"
          required
          placeholder="والد"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="success" @click="Save">ذخیره</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import vSelect from "vue-select";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import MDDropdown from "../../../components/MDDropdown";
import httpHelper from "../../../helpers/httpHelper";
import persianDate from "../../../helpers/persianDate";
export default {
  name: "newDocument",
  components: {
    MDDropdown,
    "v-select-shepa": vSelect,
  },
  data() {
    return {
      Moein: [],
      Detaileds: [],
      title: "",
      Doc: {
        des: "",
        date: "",
        number: "",
        year_id: 1,
        mdid92_state: null,
        mdid93_type: null,
        doc_details: [
          {
            index: 0,
            topic_id: null,
            detail_id: null,
            bes: 0,
            bed: 0,
            des: "",
            detaileds: [],
          },
        ],
      },
    };
  },
  watch: {
    $route(to, from) {
      this.CheckIfEdit();
    },
  },
  methods: {
    Save() {
      if (this.Doc.doc_details.length > 0) {
        if (
          this.Doc.doc_details[this.Doc.doc_details.length - 1].topic_id == null
        ) {
          this.Doc.doc_details.splice(this.Doc.doc_details.length - 1, 1);
        }
      }
      httpHelper.postData("accdoc", this.Doc).then((res) => {
        if (res.success) {
          this.$router.push("/documents");
        }
      });
    },
    addNew() {
      this.Doc.doc_details.push({
        index: this.Doc.doc_details.length,
        topic_id: null,
        detail_id: null,
        bes: 0,
        bed: 0,
        des: "",
        detaileds: [],
      });
    },
    CheckIfEdit() {
      if (this.Moein.length > 0 && this.Detaileds.length > 0) {
        if (this.$route.params.id) {
          httpHelper.setAuth();
          httpHelper
            .getData("accdoc?id=" + this.$route.params.id)
            .then((res) => {
              this.Doc = res.result;
              this.Doc.date = persianDate.getDateByFormat(this.Doc.date);
            });
        }
      }
    },
    TopicCHanged(selectedItem, x) {
      //x.topic_id = selectedItem.id;
      x.detaileds = this.Detaileds.filter((element) => {
        if (selectedItem.mdid94_types != null) {
          for (let i = 0; i < element.mdid94_type.length; i++) {
            const mditem = element.mdid94_type[i];
            if (selectedItem.mdid94_types.indexOf(mditem.mdid94_type > 0)) {
              return true;
            }
          }
        }
        return false;
        // return element.mdid94_type.filter(md=>{
        //     return selectedItem.mdid94_types.indexOf(md.mdid94_type) > 0;
        // }).length > 0;
      });
    },
  },
  created() {
    httpHelper.setAuth();
    httpHelper.getData("accchildtopic").then((res) => {
      this.Moein = res.result.map((element) => {
        return {
          text: "(" + element.code + ") " + element.name,
          value: element.id,
        };
      });
      this.CheckIfEdit();
    });
    httpHelper.getData("accchilddetail").then((res) => {
      this.Detaileds = res.result.map((element) => {
        return {
          text: "(" + element.code + ") " + element.name,
          value: element.id,
          mdid94_type: element.detail_types,
        };
      });
      this.CheckIfEdit();
    });
  },
  mounted() {
    if (this.$route.params.id != null) {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: "لیست سندهای حسابداری ",
          route: "/documents",
        },
        {
          title: "ویرایش سند",
        },
      ]);
      httpHelper
        .getData("crmcustomer?id=" + this.$route.params.id)
        .then((res) => {
          if (res.success && res.result !== null) {
            this.Input = res.result;
          }
        });
      this.title = "ویرایش سند";
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: "لیست سندهای حسابداری ",
          route: "/documents",
        },
        {
          title: "سند جدید",
        },
      ]);
      this.title = "سند جدید";
    }
  },
};
</script>